const DAY_MS = 86400000;
export function validDADate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}(?:T.*)?$/.test(value)) return null;
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return null;
  const calendar = value.slice(0, 10);
  const midnight = new Date(`${calendar}T00:00:00Z`);
  if (!Number.isFinite(midnight.getTime()) || midnight.toISOString().slice(0, 10) !== calendar) return null;
  return date;
}
export function formatDADate(value) {
  const date = validDADate(value);
  return date ? date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric', timeZone: value.length === 10 ? 'UTC' : 'Australia/Sydney' }) : null;
}
export function daysSinceStatusRecorded(app, now = new Date()) {
  const date = validDADate(app?.status_changed_at);
  if (!date || date > now) return null;
  return Math.floor((now - date) / DAY_MS);
}
export function getDATimeline(app) {
  const events = [];
  const add = (key, date, label, detail) => {
    if (validDADate(date)) events.push({ key, date, label, detail });
  };
  add('lodged', app?.lodged_date, 'Lodged', 'Application lodged date');
  add('added', app?.created_at, 'Added to SiteScope', 'SiteScope record creation, not a planning change');
  add('status', app?.status_changed_at, 'Status change recorded',
    app?.previous_status && app.previous_status !== app.status
      ? `${app.previous_status} → ${app.status || 'Unknown status'}`
      : app?.status || 'Status unknown');
  add('determined', app?.determination_date || app?.determined_date, 'Determined', 'Published determination date');
  return events.sort((a, b) => validDADate(a.date) - validDADate(b.date));
}
